// Proofreader name all file dashboard table
export const allFilesDashboardProofreaderTableData = [
  {
    field: 'UserFileName',
    header: 'File Name',
    sortable: true,
  },
  {
    field: 'ClientName',
    header: 'Client Name',
    sortable: true,
  },
  {
    field: 'DueIn',
    header: 'Client Due (Days)',
    sortable: true,
  },
  {
    field: 'VendorName',
    header: 'Vendor Name',
    sortable: true,
  },
  {
    field: 'Length',
    header: 'Length',
    sortable: true,
  },
  {
    field: 'ForeignLanguage',
    header: 'Transc Lang',
    sortable: true,
  },

  {
    field: 'LegalCategory',
    header: 'Legal Category',
    sortable: true,
  },

  {
    field: 'Action',
    header: 'Action',
    frozen: true,
    alignFrozen: 'right',
  },
];

// Proofreader name my file dashboard table
export const myFilesDashboardProofreaderTableData = [
  {
    field: 'UserFileName',
    header: 'File Name',
    sortable: true,
  },
  {
    field: 'ClientName',
    header: 'Client Name',
    sortable: true,
  },
  {
    field: 'CompanyName',
    header: 'Company Name',
    sortable: true,
  },
  {
    field: 'DueIn',
    header: 'Client Due (Days)',
    sortable: true,
  },
  {
    field: 'Originalvendorname',
    header: 'Original Vendor',
    sortable: true,
  },
  {
    field: 'VendorName',
    header: 'Vendor Name',
    sortable: true,
  },
  {
    field: 'Length',
    header: 'Length',
    sortable: true,
  },
  {
    field: 'ForeignLanguage',
    header: 'Transc Lang',
    sortable: true,
  },

  {
    field: 'LegalCategory',
    header: 'Legal Category',
    sortable: true,
  },
  {
    field: 'Status',
    header: 'Status',
    sortable: true,
  },
  {
    field: 'AdditionalOptions',
    header: 'Additional Options',
    sortable: true,
  },
  {
    field: 'ProjectManager',
    header: 'Project Manager',
    sortable: true,
  },
];

// Vendor name my stats table
export const myStatsTableData = [
  {
    field: 'MyStats',
    header: 'My Stats',
  },
  {
    field: 'DaysCurrent',
    header: 'Current',
  },
  {
    field: 'Days30',
    header: '30 Days',
  },
  {
    field: 'Days180',
    header: '180 Days',
  },
];

// Vendor name vendor file table
export const vendorsTableData = [
  {
    field: 'Name',
    header: 'Name',
    sortable: true,
  },
  {
    field: 'LevelName',
    header: 'Level',
    sortable: true,
  },
  {
    field: 'Rate',
    header: 'Rate',
    sortable: true,
  },
  {
    field: 'Rating',
    header: 'Rating',
    sortable: true,
  },
  {
    field: 'Expertise',
    header: 'Expertise',
    sortable: true,
  },
  {
    field: 'Language',
    header: 'Language',
    sortable: true,
  },
  {
    field: 'Groups',
    header: 'Groups',
    sortable: true,
  },
  {
    field: 'Services',
    header: 'Services',
    sortable: true,
  },
  {
    field: 'Country',
    header: 'Country',
    sortable: true,
  },
  {
    field: 'Status',
    header: 'Status',
    sortable: true,
  },
];

export const cgaFilesTableData = [
  {
    field: 'UserFileName',
    header: 'File Name',
    sortable: true,
    className: 'width-310',
  },
  {
    field: 'Status',
    header: 'Status',
    sortable: true,
    className: 'width-150',
  },
  {
    field: 'CGAType',
    header: 'CGA File Type',
    sortable: false,
    className: 'width-150',
  },
  {
    field: 'DueDate',
    header: 'Client Due Date',
    sortable: true,
    className: 'width-250',
  },
  {
    field: 'Duration',
    header: 'Duration',
    sortable: true,
    className: 'width-150',
  },
  {
    field: 'TotalPages',
    header: 'Total Pages',
    sortable: false,
    className: 'width-150',
  },
  {
    field: 'Actions',
    header: 'Action',
    sortable: false,
    className: 'width-150',
  }
];

export const cgaChildFilesTableData = [
  { field: 'Name', header: 'File Name', style: { minWidth: '310px !important' } },
  { field: 'Status', header: 'Status' },
];